import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';

const Reality: React.FC = () => {
  const { t } = useI18n();

  return (
    <section id="reality" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading mb-6 gradient-text leading-tight pb-2 antialiased">
            {t.reality.title}
          </h2>
          <p className="text-gray-700 max-w-4xl mx-auto mb-4 text-lg leading-relaxed">
            {t.reality.description}
          </p>
          <p className="text-gray-700 max-w-4xl mx-auto mb-4 text-lg leading-relaxed">
            {t.reality.consequences}
          </p>
          <p className="text-gray-800 max-w-4xl mx-auto font-semibold text-lg leading-relaxed">
            {t.reality.reality}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.reality.benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg p-6 shadow-lg border border-gray-100 hover:border-testingLib-blue transition-all duration-300"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center mb-4 text-white font-bold">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold mb-2 text-primary">
                {benefit.title}
              </h3>
              <p className="text-gray-600">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 max-w-3xl mx-auto p-6 rounded-lg bg-gradient-to-r from-gray-50 to-gray-100 shadow-inner">
          <blockquote className="text-lg italic text-gray-700">
            "Testing leads to failure, and failure leads to understanding."
            <footer className="mt-2 text-jest-darkRed font-medium">— Burt Rutan</footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default Reality;
